import HubLayout from '../../components/hub/HubLayout.jsx';
import ExamRunner from '../../components/hub/ExamRunner.jsx';

export default function PracticeTest({ config }) {
  const minutes = Math.round(config.practice.totalSeconds / 60);
  const briefingItems = config.practice.briefingItems || [
    { label: 'QUESTIONS', value: config.data.practice.length },
    { label: 'TIME LIMIT', value: `${minutes} MIN` },
    { label: 'PASSING SCORE', value: `${config.practice.passPct}%` },
    { label: 'FORMAT', value: 'Multiple Choice' },
  ];
  const rules = config.practice.rules || [
    `<strong>ONE PASS, ONE TIMER</strong> The ${minutes}-minute timer starts when you click Begin Exam. Pause is not available — mirroring real exam conditions.`,
    '<strong>NAVIGATE FREELY</strong> Use the question navigator to skip ahead, return to flagged items, and review before submitting.',
    '<strong>FLAG TO RETURN</strong> Mark questions you want to revisit. Flagged questions are highlighted in the navigator panel.',
    '<strong>AUTO-SUBMIT ON TIMEOUT</strong> When time expires, your current answers are scored automatically.',
    '<strong>FULL REVIEW AT END</strong> Every question you answered, with the correct answer and explanation, is shown after submission.',
  ];
  const tip = config.practice.tip || `Target roughly ${Math.max(1, Math.round(minutes / config.data.practice.length))} minute(s) per question. Anything taking 90+ seconds — flag and move on.`;

  return (
    <HubLayout config={config}>
      <ExamRunner
        questions={config.data.practice}
        domainNames={config.domainNames}
        totalSeconds={config.practice.totalSeconds}
        passPct={config.practice.passPct}
        stateKey={`${config.storagePrefix}.exam.state`}
        briefingItems={briefingItems}
        rules={rules}
        tip={tip}
        examName={`${config.title}${config.code ? ` (${config.code})` : ''}`}
      />
    </HubLayout>
  );
}
